import React from "react";
import update from "immutability-helper";

export class AuthorizedContacts extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = {
            contacts: []
        }
    }

    upd(spec) {
        this.setState(update(this.state, spec));
    }

    render(){

        let addButton = null;

        if(this.state.contacts.length < 2){
            addButton = <button type="button" id="js-add-contact" onClick={() => this.upd({ contacts: { $push: [{ name: "", tel: "" }] } }) } >Add Additional Contact</button>
        }
        return <div className="authorized-contacts">
            {
                this.state.contacts.map( (e, idx) => (<div key={idx} className="authorized-contact__entry">
                    <h3>Additional Contact</h3>
                    <fieldset>
                        <div className="input-group">
                            <label>Name</label>
                            <input
                                name="authorized-contact-name[]"
                                type="text"
                                value={e.name}
                                onChange={(ev) => this.upd({ contacts: { [idx]: { name: { $set: ev.target.value } } }  })} />
                        </div>
                        <div className="input-group">
                            <label>Number</label>
                            <input 
                                name="authorized-contact-tel[]"
                                type="text"
                                value={e.tel}
                                onChange={(ev) => this.upd({ 
                                    contacts: {
                                        [idx]: { 
                                            tel: { $set: ev.target.value } 
                                        } 
                                    } 
                                })}
                            />
                        </div>
                        <button type="button" onClick={() => {
                            if(confirm("Remove Contact?")){ // eslint-disable-line
                                this.upd({ contacts: { $splice: [[idx, 1]] } })
                            }
                        }}>Remove Contact</button>
                    </fieldset></div>) )
            }
            <p className="add-button-intro">Add an additional person authorised to collect the children.</p>
            {addButton}
        </div>
    }
}


// WEBPACK FOOTER //
// ./flexi/AuthorizedContacts.jsx